import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import moment from 'moment';
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ClockIcon',
    props: {
        date: {}
    },
    setup(__props) {
        const props = __props;
        const clockIcon = computed(() => {
            const d = moment(props.date);
            let hour = parseInt(d.format('h'));
            const minutes = parseInt(d.format('m'));
            let thirty = false;
            if (minutes >= 55) {
                hour++;
            }
            else if (minutes >= 20) {
                thirty = true;
            }
            return `clock-${hourName(hour)}${thirty ? '-thirty' : ''}`;
        });
        function hourName(hour) {
            switch (hour) {
                case 1: return 'one';
                case 2: return 'two';
                case 3: return 'three';
                case 4: return 'four';
                case 5: return 'five';
                case 6: return 'six';
                case 7: return 'seven';
                case 8: return 'eight';
                case 9: return 'nine';
                case 10: return 'ten';
                case 11: return 'eleven';
                case 12: return 'twelve';
            }
            throw 'invalid hour';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Icon, {
                name: clockIcon.value,
                title: _ctx.$dateTime(__props.date)
            }, null, 8, ["name", "title"]));
        };
    }
});
